/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Solid_Color_LabelInputs */

const en_image_export_solid_color_label = /** @type {(inputs: Image_Export_Solid_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solid Color (for keying)`)
};

const fr_image_export_solid_color_label = /** @type {(inputs: Image_Export_Solid_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur unie (pour le keying)`)
};

const de_image_export_solid_color_label = /** @type {(inputs: Image_Export_Solid_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volltonfarbe (für die Kennzeichnung)`)
};

const it_image_export_solid_color_label = /** @type {(inputs: Image_Export_Solid_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore pieno (per la codifica)`)
};

const ru_image_export_solid_color_label = /** @type {(inputs: Image_Export_Solid_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сплошной цвет (для ключа)`)
};

const es_image_export_solid_color_label = /** @type {(inputs: Image_Export_Solid_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color sólido (para codificación)`)
};

const zh_cn2_image_export_solid_color_label = /** @type {(inputs: Image_Export_Solid_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`纯色（用于抠像）`)
};

const ja_image_export_solid_color_label = /** @type {(inputs: Image_Export_Solid_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単色（キーイング用）`)
};

const hi_image_export_solid_color_label = /** @type {(inputs: Image_Export_Solid_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठोस रंग (कीबोर्डिंग के लिए)`)
};

const pt_pt2_image_export_solid_color_label = /** @type {(inputs: Image_Export_Solid_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor sólida (para chaveamento)`)
};

/**
* | output |
* | --- |
* | "Solid Color (for keying)" |
*
* @param {Image_Export_Solid_Color_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_solid_color_label = /** @type {((inputs?: Image_Export_Solid_Color_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Solid_Color_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_solid_color_label(inputs)
	if (locale === "de") return de_image_export_solid_color_label(inputs)
	if (locale === "it") return it_image_export_solid_color_label(inputs)
	if (locale === "ru") return ru_image_export_solid_color_label(inputs)
	if (locale === "es") return es_image_export_solid_color_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_solid_color_label(inputs)
	if (locale === "ja") return ja_image_export_solid_color_label(inputs)
	if (locale === "hi") return hi_image_export_solid_color_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_solid_color_label(inputs)
	return en_image_export_solid_color_label(inputs)
});